import { axios } from '@/utils/request'

export function sendCV (data) {
    return axios({
        url: '/seekers/',
        method: 'post',
        data: data
    })
}
